import { CheckoutRoute } from "@swiggy-private/checkout-core";

/**
 * Header sent only on GPO (get-payment-options) calls to indicate the entry/trigger
 * point of the call so downstream services can segment by where the call originated.
 */
export const GPO_SOURCE_HEADER = "source";

export enum GPO_SOURCE {
    PAYMENTS_PAGE = "PAYMENTS_PAGE",
    MENU_PAGE = "MENU_PAGE",
    CART_PAGE = "CART_PAGE",
}

// Routes that originate from the menu / AIP quick-checkout entry point.
export const MENU_PAGE_ROUTES: string[] = [CheckoutRoute.QUICK_CHECKOUT];
